import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import userGlobalConfig from "../../constants/globalConfig";
import { AuthContext } from "../../context/authContext";
import { useFormik } from "formik";
import { LogininitialValues, loginValidationSchema } from "../../validations";
import { toast } from "react-toastify";
import { useAdminLogin } from "../../hooks/auth/loginApi";
import { secureStorage } from "../../utils/secureStorage";
// import { initializeCsrfToken } from "../../utils/csrf";

const LoginScreen: React.FC = () => {
  const navigate = useNavigate();
  const [showEye, setShowEye] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setisAuthenticated } = useContext(AuthContext);
  const { mutateAsync } = useAdminLogin();

  const { values, touched, errors, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: LogininitialValues,
      validationSchema: loginValidationSchema,
      onSubmit: async () => {
        setLoading(true);
        
        // Add timeout to prevent stuck loading state
        const timeoutId = setTimeout(() => {
          if (loading) {
            setLoading(false);
            toast.error('Login request timed out. Please try again.');
          }
        }, 30000); // 30 second timeout
        
        try {
          const res: any = await mutateAsync({
            email: values.email,
            password: values.password,
          });
          
          clearTimeout(timeoutId);
          
          if (res?.status === true || res?.success === true) {
            // Use secure storage instead of localStorage
            secureStorage.setItem(
              userGlobalConfig.ADMIN_DETAILS,
              JSON.stringify(res?.data)
            );
            secureStorage.setItem(userGlobalConfig.TOKEN, res?.token);
            
            // Show success message
            toast.success(res?.message || 'Login successful');
            
            // Set authentication state and navigate
            setisAuthenticated(true);
            
            // CSRF protection temporarily disabled
            // initializeCsrfToken().then(() => {
            //   console.log("✅ CSRF token initialized");
            // }).catch((error) => {
            //   console.error("⚠️  Failed to initialize CSRF token:", error);
            // });
            
            // Navigate immediately after setting auth state
            navigate("/dashboard", { replace: true });
          } else {
            toast.error(res?.message || 'Login failed');
            setLoading(false);
          }
        } catch (error: any) {
          clearTimeout(timeoutId);
          console.error('Login error:', error);
          const errorMessage = error?.response?.data?.message ||
                              error?.message ||
                              'Login failed. Please try again.';
          toast.error(errorMessage);
          setLoading(false);
        }
      },
    });

  return (
    <section className="login-section">
      <div className="container-fluid g-0">
        <div className="row g-0">
          <div className="col-md-12">
            <div className="login-main-blk">
              <div className="login-form-blk">
                <div className="login-heading">
                  <h1>login</h1>
                </div>
                <form>
                  <div className="form-group">
                    <label htmlFor="email">Your email</label>
                    <input
                      className={
                        errors.email && touched.email
                          ? "form-control border border-danger"
                          : "form-control"
                      }
                      id="email"
                      placeholder="Email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.email && touched.email && (
                      <p className="error">{errors.email}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="psw">Password</label>

                    <div className="p-relative">
                      <span className="eye">
                        <i
                          className={
                            !showEye
                              ? "fa-regular fa-eye"
                              : "fa-regular fa-eye-slash"
                          }
                          onClick={() => setShowEye(!showEye)}
                        />
                      </span>
                      <input
                        id="psw"
                        type={!showEye ? "password" : "text"}
                        className={
                          errors.email && touched.email
                            ? "form-control border border-danger"
                            : "form-control"
                        }
                        placeholder="Password"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>

                    {errors.password && touched.password && (
                      <p className="error">{errors.password}</p>
                    )}
                  </div>
                  <div className="login-btn-blk">
                    <button
                      type="button"
                      disabled={loading}
                      className="btn primary-btn"
                      onClick={() => handleSubmit()}>
                      {loading ? "Loading..." : "Login"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginScreen;
